export const UsageLogTypes = {
    ProjectFolder: 'project-folder',
    Model: 'model'
} as const;

export const UsageLogEvent = {
    Added: 'added',
    Switched: 'switched'
} as const;

export const SourceApp = {
    CHAT_SERVER: 'CHAT SERVER'
} as const;

export enum UsageEventType {
    Usage = 0,
    Audit = 1
}

export type UsageLogTypesValues =
    (typeof UsageLogTypes)[keyof typeof UsageLogTypes];
export type UsageLogEventValues =
    (typeof UsageLogEvent)[keyof typeof UsageLogEvent];
export type SourceAppValues = (typeof SourceApp)[keyof typeof SourceApp];
